import styled from '@emotion/styled';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';
import { Box, Flex, themeGet } from '@lightspeed/flame/Core';
import { ModalBody } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

import { ActionsDropdown } from './DevicesPage/ActionsDropdown';

// TODO: Remove this one day when we get a fix in mainline Flame
export interface Theme {
  theme?: any;
}

export const verticalAlign = {
  verticalAlign: 'baseline',
};

export const PaddedCardSection = styled(CardSection)`
  padding: ${themeGet('space.4')};
`;

export const DeviceIconWrapper = styled(Flex)<Theme>`
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  background-color: transparent;
  border: dashed 2px ${themeGet('colors.gray-100')};
  border-radius: 10%;
`;

export const SizedImage = styled('img')`
  height: 100%;
  width: 100%;
  max-width: 600px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  @media screen and (max-width: 992px) {
    object-fit: cover;
  }
`;

export const ShapedCard = styled(Card)`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

export const OptionFlex = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
`;

export const IconBox = styled(Box)`
  width: 5%;
`;
export const TextBox = styled(Box)<Theme>`
  width: 65%;
  line-height: ${themeGet('lineHeights.4')};
`;
export const ButtonBox = styled(Box)`
  width: 30%;
  text-align: right;
`;

export const StyledModalBody = styled(ModalBody)<Theme>`
  border-bottom: 1px solid ${themeGet('modalStyles.header.border')};
`;

export const StyledFlexCircle = styled(Flex)`
  align-items: center;
  align-self: center;
  justify-content: center;
  flex: 1 0 auto;
  background-color: ${themeGet('colors.gray-300')};
  border: 2px solid ${themeGet('colors.gray-400')};
  border-radius: 100%;
  width: 70px;
  height: 70px;
`;

export const LinkButtonText = styled(Button)`
  margin-top: ${themeGet('space.2')};
  @media screen and (min-width: 992px) {
    margin-top: ${themeGet('space.0')};
  }
`;

export const LinkButtonLightText = styled(LinkButtonText)`
  color: ${themeGet('colors.white')} !important;
`;

export const LinkButtonDarkText = styled(LinkButtonText)`
  color: ${themeGet('colors.gray-850')} !important;
`;

export const StyledInfoAlert = styled(Alert)`
  border: 1px solid ${themeGet('colors.blue-100')};
  box-shadow: none;
`;

export const StyledWarningAlert = styled(Alert)`
  border: 1px solid ${themeGet('colors.orange-100')};
  box-shadow: none;
`;

export const StyledDangerAlert = styled(Alert)`
  border: 1px solid ${themeGet('colors.maple-100')};
  box-shadow: none;
`;

export const AlertText = styled(Text)`
  padding-right: ${themeGet('space.3')};
  color: ${themeGet('colors.gray-850')};
`;

export const StyledFlexBox = styled(Flex)`
  margin-left: ${themeGet('space.3')};
  flex: 1 1 auto;
  flex-direction: column;
  @media screen and (min-width: 992px) {
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const StyledActionsDropdown = styled(ActionsDropdown)`
  padding: 0px;
  &:not(:focus),
  &:focus,
  &:active {
    background: none;
    background-image: none;
    outline: none;
    border: none;
    box-shadow: none;
  }
  &:hover {
    text-decoration: underline;
  }

  > span > span:not(:first-of-type) {
    margin-left: 0px !important;
  }
`;
